<template>
  <h1>404 - Not found</h1>
</template>

<script>
  export default {
    name: 'Error404View',
  };
</script>

